import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=63968367&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63968367",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63968367')) {
      api.createRecord('63968367', component.options)
    } else {
      api.reload('63968367', component.options)
    }
    module.hot.accept("./roles.vue?vue&type=template&id=63968367&scoped=true&", function () {
      api.rerender('63968367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/actions/modals/roles.vue"
export default component.exports